import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TeamIntro from "./components/TeamIntro";
import Team from "./components/Team";
import AligneursDetail from "./components/AligneursDetail";
import ChirurgieDetail from "./components/ChirurgieDetail";
import Treatments from "./components/Treatments";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const Home = () => {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <TeamIntro />
        <Team />
        <AligneursDetail />
        <ChirurgieDetail />
        <Treatments />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
